module.exports = "/shifts/modal-tor-view-7c83df.html";